import Vue from "vue";
import "@babel/polyfill";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
// import firebase from "firebase/app";
// import "firebase/messaging";
import Validations from "@/../../GeneralComponents/Validations.js";

Vue.config.productionTip = false;

// Firebase(Initialize)
// var firebaseConfig = {
//   apiKey: "AIzaSyBH9NcCifmMySvVxyy9NgsF7qwg_uVfDHY",
//   authDomain: "pacustomers-bee02.firebaseapp.com",
//   databaseURL: "https://pacustomers-bee02.firebaseio.com",
//   projectId: "pacustomers-bee02",
//   storageBucket: "pacustomers-bee02.appspot.com",
//   messagingSenderId: "502133024473",
//   appId: "1:502133024473:web:0a2dc3e1a89e515ca640c8",
// };

// firebase.initializeApp(firebaseConfig);

// export const firebaseMessaging = firebase.messaging();

// Validations
export const v = Validations;

export const V = Validations;

// EventBus
export const EventBus = new Vue();

store.dispatch("startApp").then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
